import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, of, switchMap } from 'rxjs';

import { HotelConfigModel } from '../../models';
import { HotelService } from '../../services';

import * as HotelActions from './hotel.actions';

@Injectable()
export class HotelEffects {
  private actions$ = inject(Actions);
  private hotelService = inject(HotelService);

  loadHotelByUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HotelActions.loadHotelByUser),
      switchMap((action) => this.hotelService.getHotelByUser(action.userUid)),
      map((hotel) => HotelActions.setHotel({ hotel })),
    ),
  );

  loadHotel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HotelActions.loadHotel),
      switchMap((action) => this.hotelService.getHotel(action.hotelUid)),
      map((hotel) => HotelActions.setHotel({ hotel })),
    ),
  );

  loadHotelRooms$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HotelActions.setHotel),
      switchMap((action) => this.hotelService.getRooms(action.hotel.uid)),
      map((rooms) => HotelActions.setHotelRooms({ rooms })),
    ),
  );

  loadHotelConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HotelActions.setHotel),
      switchMap((action) => this.hotelService.getConfigHotel(action.hotel.uid)),
      map((hotelConfig) => HotelActions.setHotelConfig({ hotelConfig: hotelConfig as HotelConfigModel })),
    ),
  );

  loadEstablishmentType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HotelActions.setHotelConfig),
      switchMap((action) => {
        if (action.hotelConfig?.establishmentType) {
          return this.hotelService.getEstablishmentType(action.hotelConfig.establishmentType);
        } else {
          return of(null);
        }
      }),
      map((establishmentType) => HotelActions.setEstablishmentType({ establishmentType: establishmentType ?? null })),
    ),
  );

  updateHotelConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HotelActions.updateHotelConfig),
      switchMap((action) => this.hotelService.updateConfigHotel(action.hotelUid, action.config)),
      map(() => HotelActions.updateHotelConfigSuccess()),
    ),
  );
}
